import { render, staticRenderFns } from "./NotesCard.vue?vue&type=template&id=49ce0728&scoped=true"
import script from "./NotesCard.vue?vue&type=script&lang=js"
export * from "./NotesCard.vue?vue&type=script&lang=js"
import style0 from "./NotesCard.vue?vue&type=style&index=0&id=49ce0728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce0728",
  null
  
)

export default component.exports